import { render } from "./PartnerMainView.vue?vue&type=template&id=325edb73&scoped=true"
import script from "./PartnerMainView.vue?vue&type=script&lang=js"
export * from "./PartnerMainView.vue?vue&type=script&lang=js"

import "./PartnerMainView.vue?vue&type=style&index=0&id=325edb73&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325edb73"]])

export default __exports__